module.exports = __webpack_public_path__ + "static/u1-4d04a49b1c8f09203fcde9bcb3136c5d.png";